export default __webpack_public_path__ + "static/media/how-it-works_01.c3df9539.png";